import { Navigate } from 'react-router'
import { useAuth } from '@/features/auth/hooks/use-auth'
import { SUPPORTED_LANGS, type SupportedLang } from '@/shared/hooks'

/**
 * Component that redirects from `/` to `/:lang`.
 *
 * Detection priority:
 * 1. User's locale from profile (if authenticated) - handled by LanguageLayout after redirect
 * 2. Browser language (navigator.language)
 * 3. Fallback to 'en'
 *
 * Note: The user's locale from profile is handled by LanguageLayout after the initial redirect.
 * This component only handles the browser detection for the initial redirect.
 */
export function LanguageRedirect() {
  const { isLoading } = useAuth()

  // Wait for auth to load to avoid flash
  if (isLoading) {
    return null
  }

  // Detect language from browser
  const browserLang = navigator.language.toLowerCase()
  const detectedLang: SupportedLang = browserLang.startsWith('fr') ? 'fr' : 'en'

  // Validate the detected language
  const targetLang = SUPPORTED_LANGS.includes(detectedLang) ? detectedLang : 'en'

  return <Navigate to={`/${targetLang}`} replace />
}
